import { Wrap, WrapItem } from '@fiverr-private/layout_components';
import { Box } from '@fiverr-private/theme';
import type { ActiveSideFiltersType, FilterType, SelectedFilter } from '@fiverr-private/listing_types';
import { hiddenScrollbarStyles } from '../../hidden_scrollbar/hiddenScrollbar.ve.css';
import { FilterRowItem } from './components/FilterRowItem';
import { buildFilterRowItems } from './utils';
import type { CategoryExposure, FilterRowItemData, FiltersModalTriggerProps } from './FilterRow.types';
import { touchRowStyles, touchTriggerStyles } from './FilterRow.ve.css';

type FilterTriggerItem = Extract<FilterRowItemData, { type: 'filterTrigger' }>;

interface FilterRowProps {
    filters: FilterType[];
    activeFilters: ActiveSideFiltersType;
    selectedFiltersHierarchy: SelectedFilter[];
    currencySymbol: string;
    filtersModalProps: FiltersModalTriggerProps;
    categoryExposure?: CategoryExposure;
    isSticky?: boolean;
    isTouch?: boolean;
}

const isFilterTrigger = (item: FilterRowItemData): item is FilterTriggerItem => item.type === 'filterTrigger';

const isScrollable = (item: FilterRowItemData) => item.type !== 'filterTrigger' && item.type !== 'divider';

export const FilterRow = ({
    filters,
    activeFilters,
    selectedFiltersHierarchy,
    currencySymbol,
    filtersModalProps,
    categoryExposure,
    isSticky = false,
    isTouch = false,
}: FilterRowProps) => {
    const items = buildFilterRowItems({
        filters,
        activeFilters,
        selectedFiltersHierarchy,
        currencySymbol,
        filtersModalProps,
        categoryExposure,
    });

    if (isTouch) {
        const filterTriggerItem = items.find(isFilterTrigger);

        return (
            <Box
                position="relative"
                height="44px"
                width="100%"
                minWidth="0px"
                marginTop={isSticky ? '4' : '0'}
                marginBottom="3"
            >
                <Wrap
                    className={`${hiddenScrollbarStyles} ${touchRowStyles}`}
                    gap="2"
                    wrap="nowrap"
                    overflowX="auto"
                    alignItems="center"
                    height="44px"
                    width="100%"
                    minWidth="0px"
                    paddingRight="7"
                >
                    {items.filter(isScrollable).map((item) => (
                        <WrapItem key={item.rowKey} flexShrink="0">
                            <FilterRowItem {...item} />
                        </WrapItem>
                    ))}
                </Wrap>
                {filterTriggerItem && (
                    <Box
                        className={touchTriggerStyles}
                        position="absolute"
                        top="0px"
                        left="0px"
                        zIndex="2"
                        display="flex"
                        alignItems="center"
                        height="44px"
                        paddingLeft="6"
                        paddingRight="2"
                    >
                        <FilterRowItem {...filterTriggerItem} props={{ ...filterTriggerItem.props, iconOnly: true }} />
                    </Box>
                )}
            </Box>
        );
    }

    return (
        <Wrap gap="2" alignItems="center" marginTop={isSticky ? '4' : '6'}>
            {items.map((item) => (
                <WrapItem key={item.rowKey} {...(item.type === 'divider' ? { marginX: '2' } : {})}>
                    <FilterRowItem {...item} />
                </WrapItem>
            ))}
        </Wrap>
    );
};
